<template>
  <div>
    <!-- Overlay lateral -->
    <div
      v-if="menuOpen"
      class="nav-overlay"
      @click="toggleMenu"
    ></div>

    <!-- Sidebar -->
    <aside
      :class="[
        'nav-sidebar',
        menuOpen ? 'nav-sidebar--open' : 'nav-sidebar--closed'
      ]"
      @click.stop
    >
      <div class="nav-sidebar__header">
        <div class="nav-sidebar__brand">
          <span class="nav-sidebar__dot"></span>
          <span class="nav-sidebar__title">Panel</span>
        </div>
        <button
          class="nav-sidebar__close"
          type="button"
          @click="toggleMenu"
        >
          ✕
        </button>
      </div>

      <div
        class="nav-sidebar__user"
        v-if="user"
      >
        <div class="nav-sidebar__avatar">
          <span>{{ userInitials }}</span>
        </div>
        <div class="nav-sidebar__user-info">
          <p class="nav-sidebar__user-name">
            {{ user.username || 'Usuario' }}
          </p>
          <p class="nav-sidebar__user-email">
            {{ user.email }}
          </p>
        </div>
      </div>

      <nav class="nav-sidebar__menu">
        <!-- Inicio -->
        <router-link
          v-if="user"
          to="/dashboard"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Inicio</span>
        </router-link>

        <!-- Gestión de productos -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/productos"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Gestión de productos</span>
        </router-link>

        <!-- Unidades y seriales -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/unidades"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Unidades y seriales</span>
        </router-link>

        <!-- Relación de unidades -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/relacion-unidades"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Relación de unidades</span>
        </router-link>

        <!-- Órdenes de entrada -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/orden-entrada"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Órdenes de entrada</span>
        </router-link>

        <!-- Centros de activación -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/centros-activacion"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Centros de activación</span>
        </router-link>

        <!-- Órdenes de entrega -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/ordenes-entrega"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Órdenes de entrega</span>
        </router-link>

        <!-- Órdenes de recolección -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/ordenes-recoleccion"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Órdenes de recolección</span>
        </router-link>

        <!-- Inventario global -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/inventario"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Inventario global</span>
        </router-link>

        <!-- Historial por unidad -->
        <router-link
          v-if="$canView && $canView('superadministrador', 'administrador')"
          to="/dashboard/historial-unidades"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Historial por unidad</span>
        </router-link>

        <!-- Editar perfil -->
        <router-link
          v-if="user"
          :to="`/dashboard/user/edit/${user.token}`"
          class="nav-sidebar__link"
          @click="closeMenu"
        >
          <span class="nav-sidebar__link-dot"></span>
          <span>Editar mi perfil</span>
        </router-link>

        <!-- Logout -->
        <button
          type="button"
          class="nav-sidebar__link nav-sidebar__link--danger"
          @click="logoutAndClose"
        >
          <span>Cerrar sesión</span>
        </button>
      </nav>
    </aside>

    <!-- Top navbar -->
    <header class="app-navbar">
      <div class="app-navbar__inner">
        <div class="app-navbar__left">
          <button
            type="button"
            class="app-navbar__icon-button"
            @click="toggleMenu"
          >
            <span class="app-navbar__icon-bar"></span>
            <span class="app-navbar__icon-bar"></span>
          </button>

          <div class="app-navbar__brand">
            <span class="app-navbar__badge"></span>
            <span class="app-navbar__title">Almacén</span>
          </div>
        </div>

        <!-- Botones rápidos en navbar -->
        <div
          class="app-navbar__center"
          v-if="user"
        >
          <router-link
            to="/dashboard"
            class="app-navbar__nav-pill"
          >
            Inicio
          </router-link>

        
        </div>

        <div
          class="app-navbar__right"
          v-if="user"
        >
          <span class="app-navbar__user-name">
            {{ shortName }}
          </span>
          <div class="app-navbar__avatar">
            <span>{{ userInitials }}</span>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'NavBar',
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    ...mapState(['user', 'roleToken']),

    shortName() {
      if (!this.user || !this.user.username) return 'Usuario';
      const [first] = this.user.username.split(' ');
      return first.length > 14 ? `${first.slice(0, 14)}…` : first;
    },

    userInitials() {
      if (!this.user || !this.user.username) return 'U';
      const parts = this.user.username.split(' ').filter(Boolean);
      const initials =
        (parts[0]?.[0] || '') + (parts[1]?.[0] || '');
      return (initials || 'U').toUpperCase();
    },
  },
  methods: {
    ...mapActions(['logout']),

    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },

    closeMenu() {
      if (this.menuOpen) this.menuOpen = false;
    },

    logoutAndClose() {
      this.logout();
      this.closeMenu();
      this.$router.push('/login');
    },
  },
};
</script>

<style scoped>
.app-navbar {
  position: fixed;
  inset: 0 0 auto 0;
  z-index: 40;
  backdrop-filter: blur(22px);
  background: linear-gradient(
    135deg,
    rgba(15, 23, 42, 0.9),
    rgba(15, 23, 42, 0.96)
  );
  border-bottom: 1px solid rgba(148, 163, 184, 0.45);
}

.app-navbar__inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0.35rem 1.25rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app-navbar__left {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* Centro: botones rápidos */
.app-navbar__center {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 520px;
}

.app-navbar__nav-pill {
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.7);
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.25),
    rgba(15, 23, 42, 0.96)
  );
  padding: 0.22rem 0.7rem;
  font-size: 0.75rem;
  text-decoration: none;
  color: #e5e7eb;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition:
    background 0.16s ease,
    border-color 0.16s ease,
    box-shadow 0.18s ease,
    transform 0.08s ease;
}

.app-navbar__nav-pill:hover {
  background: rgba(15, 23, 42, 1);
  border-color: rgba(148, 163, 184, 0.95);
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.95);
}

.app-navbar__nav-pill.router-link-active {
  background: radial-gradient(
    circle at 0 0,
    rgba(129, 140, 248, 0.95),
    rgba(30, 64, 175, 1)
  );
  border-color: rgba(129, 140, 248, 1);
  box-shadow: 0 0 14px rgba(129, 140, 248, 0.8);
  color: #fff;
}

.app-navbar__nav-pill:active {
  transform: translateY(0);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 1);
}

.app-navbar__icon-button {
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.55);
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.28),
    rgba(15, 23, 42, 0.98)
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 0;
}

.app-navbar__icon-bar {
  width: 14px;
  height: 1.5px;
  border-radius: 999px;
  background: rgba(248, 250, 252, 0.94);
}

.app-navbar__brand {
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.app-navbar__badge {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  background: radial-gradient(circle, #22c55e, #16a34a);
  box-shadow: 0 0 8px rgba(34, 197, 94, 0.85);
}

.app-navbar__title {
  font-size: 0.8rem;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: #e5e7eb;
}

.app-navbar__right {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.app-navbar__user-name {
  font-size: 0.8rem;
  color: #cbd5f5;
}

.app-navbar__avatar {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.28),
    rgba(15, 23, 42, 1)
  );
  border: 1px solid rgba(148, 163, 184, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #e5e7eb;
}

/* Mobile: ocultamos los pills para no apretar tanto */
@media (max-width: 640px) {
  .app-navbar__center {
    display: none;
  }
}

/* Overlay */
.nav-overlay {
  position: fixed;
  inset: 0;
  background: radial-gradient(
    circle at 0 0,
    rgba(148, 163, 184, 0.24),
    rgba(15, 23, 42, 0.96)
  );
  z-index: 30;
}

/* Sidebar */
.nav-sidebar {
  position: fixed;
  inset: 0 auto 0 0;
  width: 260px;
  max-width: 80vw;
  z-index: 100;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.26),
      rgba(15, 23, 42, 0.98)
    );
  backdrop-filter: blur(26px);
  border-right: 1px solid rgba(148, 163, 184, 0.55);
  display: flex;
  flex-direction: column;
  padding: 0.75rem 0.9rem 0.9rem 0.9rem;
  transform: translateX(-100%);
  transition: transform 0.24s ease-out;
}

.nav-sidebar--open {
  transform: translateX(0);
}

.nav-sidebar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.nav-sidebar__brand {
  display: flex;
  align-items: center;
  gap: 0.35rem;
}

.nav-sidebar__dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: radial-gradient(circle, #22c55e, #16a34a);
}

.nav-sidebar__title {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #e5e7eb;
}

.nav-sidebar__close {
  border: none;
  background: transparent;
  color: #e2e8f0;
  cursor: pointer;
  font-size: 0.9rem;
}

.nav-sidebar__user {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.6rem 0.6rem;
  border-radius: 1rem;
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(148, 163, 184, 0.55);
  margin-bottom: 0.75rem;
}

.nav-sidebar__avatar {
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: radial-gradient(
      circle at 0 0,
      rgba(148, 163, 184, 0.28),
      rgba(15, 23, 42, 1)
    );
  border: 1px solid rgba(148, 163, 184, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  color: #e5e7eb;
}

.nav-sidebar__user-info {
  min-width: 0;
}

.nav-sidebar__user-name {
  font-size: 0.8rem;
  color: #e5e7eb;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.nav-sidebar__user-email {
  font-size: 0.72rem;
  color: #94a3b8;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.nav-sidebar__menu {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.nav-sidebar__link {
  width: 100%;
  border-radius: 0.9rem;
  padding: 0.55rem 0.65rem;
  border: 1px solid transparent;
  background: rgba(15, 23, 42, 0.84);
  color: #e5e7eb;
  font-size: 0.8rem;
  text-align: left;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  text-decoration: none;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    transform 0.08s ease,
    box-shadow 0.18s ease;
}

.nav-sidebar__link:hover {
  background: rgba(15, 23, 42, 0.96);
  border-color: rgba(148, 163, 184, 0.8);
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.95);
}

.nav-sidebar__link.router-link-active {
  background: radial-gradient(
    circle at 0 0,
    rgba(129, 140, 248, 0.85),
    rgba(30, 64, 175, 1)
  );
  border-color: rgba(129, 140, 248, 1);
  box-shadow: 0 0 20px rgba(129, 140, 248, 0.9);
  color: #fff;
}

.nav-sidebar__link:active {
  transform: translateY(0);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 1);
}

.nav-sidebar__link-dot {
  width: 5px;
  height: 5px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.95);
}

.nav-sidebar__link--danger {
  background: rgba(127, 29, 29, 0.88);
  border-color: rgba(248, 113, 113, 0.9);
  color: #fee2e2;
  justify-content: center;
  margin-top: 0.25rem;
}

.nav-sidebar__link--danger:hover {
  background: rgba(127, 29, 29, 0.96);
  border-color: rgba(248, 113, 113, 1);
}
</style>
